import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

// admin_homepage_ranking requirement - website-admin-only "premium placement" control. Ranked
// listings (1-100, shared across listings - RentalItem is one shared collection across every
// vertical) lead the homepage's cross-vertical featured/trending rail; this deliberately does
// NOT change where the listing sits in its own vertical's browse/search page.
export default function HomepageRankModal({ item, show, onHide, onSave }) {
  const [rank, setRank] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setRank(item?.homepageRank != null ? String(item.homepageRank) : '');
    setError('');
  }, [item, show]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await onSave(rank === '' ? null : Number(rank));
      onHide();
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to update the homepage rank.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title>Homepage rank{item ? `: ${item.name}` : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="small text-muted">
            Ranked listings (1–100) lead the homepage's featured/trending section, across every
            vertical — 1 is the most prominent. Multiple listings can share the same rank, including across verticals. This does not change where this listing appears in
            its own vertical's browse page.
          </p>
          {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}
          <Form.Group>
            <Form.Label>Rank (1–100)</Form.Label>
            <Form.Control
              type="number" min={1} max={100} value={rank}
              placeholder="Not ranked"
              onChange={(e) => setRank(e.target.value)}
            />
            <Form.Text className="text-muted">Leave blank to remove this listing from the ranked rail.</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button type="submit" variant="primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
